import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LoginUiFlowConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	// TODO: remove this config as part of OBGB-10023
	showHeaderAndFooterForNDCflow(): boolean {
		return this.configService.get<boolean>((x) => x.matCoreUi.dialogHeaderFooterNDC, false);
	}
}
